module.exports = __webpack_public_path__ + "static/media/012-line-yellow.abfb0d37.svg";